import { appConfig } from 'src/app/app-config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const queryRetry = (failureCount: number, error: any) => {
    if (appConfig.env !== 'production') {
        // eslint-disable-next-line no-console
        console.log('React Query Error', error);
    }

    const maxRetries = Number(appConfig.queryRetryAmount);
    if (failureCount > (Number.isNaN(maxRetries) ? 2 : maxRetries)) return false;

    const errorMessage = error.response?.data?.message ?? '';
    const errorStatus = error.response?.status ?? 0;

    return !errorStatus || errorStatus >= 405 || errorMessage === 'request_limit_exceeded';
};
